/* AFTER FIVE: home page and site chrome (workstream H). Loaded with defer by
   sections/header.liquid, after global.js. No dependencies. */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function each(selector, fn) {
    Array.prototype.forEach.call(doc.querySelectorAll(selector), function (node) {
      if (node.dataset.afReady) return;
      node.dataset.afReady = 'true';
      fn(node);
    });
  }

  /* Header: the overlay ("transparent") state needs a hero as the page's first
     section, and gives way to the solid header while the menu drawer or the
     search overlay is open. */
  function initHeader() {
    each('.af-header', function (header) {
      if (root.classList.contains('af-header-overlay') && !doc.querySelector('.af-hero--lead')) {
        root.classList.remove('af-header-overlay');
      }

      var drawer = header.querySelector('#Details-menu-drawer-container');
      var search = header.querySelector('details-modal.header__search details');
      var section = header.closest('.section-header');
      var sync = function () {
        var open = (drawer && drawer.hasAttribute('open')) || (search && search.hasAttribute('open'));
        header.classList.toggle('af-header--solid', !!open);
        /* lifts the header above sticky bars while the drawer or search is open (af-chrome.css) */
        if (section) section.classList.toggle('af-header-open', !!open);
      };
      [drawer, search].forEach(function (details) {
        if (!details) return;
        new MutationObserver(sync).observe(details, { attributes: true, attributeFilter: ['open'] });
      });
      sync();

      /* Wishlist: where the app draws its own heart, the theme's link steps aside. */
      var icons = header.querySelector('.header__icons');
      var fallback = icons && icons.querySelector('.af-header__wishlist');
      if (fallback) {
        var swap = function () {
          if (!icons.querySelector('.nm-wishlist-inline-access-button')) return false;
          fallback.hidden = true;
          return true;
        };
        if (!swap()) {
          var observer = new MutationObserver(function () {
            if (swap()) observer.disconnect();
          });
          observer.observe(icons, { childList: true, subtree: true });
        }
      }
    });
  }

  /* Slideshows with a pause button (announcement bar, hero) start paused when the
     shopper asks for reduced motion; the theme's component only checks that for
     slideshows without the button. */
  function initSlideshows() {
    if (!reduceMotion.matches) return;
    each('slideshow-component', function (component) {
      if (component.sliderAutoplayButton && component.autoplayButtonIsSetToPlay && typeof component.autoPlayToggle === 'function') {
        component.autoPlayToggle();
      }
    });
  }

  /* Product carousels: previous and next move one screenful of cards. */
  function initCarousels() {
    each('[data-af-carousel]', function (carousel) {
      var track = carousel.querySelector('[data-af-carousel-track]');
      var previous = carousel.querySelector('[data-af-carousel-nav="previous"]');
      var next = carousel.querySelector('[data-af-carousel-nav="next"]');
      if (!track || !previous || !next) return;
      var update = function () {
        var end = track.scrollWidth - track.clientWidth - 1;
        previous.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= end;
      };
      var move = function (direction) {
        track.scrollBy({ left: direction * track.clientWidth, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* Brand marquee: the HTML holds each logo once. Repeat the set until it covers
     the row, start the movement and show the pause button (WCAG 2.2.2). Under
     "reduce motion" it stays a still row that scrolls by hand. */
  function initMarquees() {
    each('[data-af-marquee]', function (marquee) {
      var viewport = marquee.querySelector('[data-af-marquee-viewport]');
      var set = marquee.querySelector('[data-af-marquee-set]');
      var button = marquee.querySelector('[data-af-marquee-toggle]');
      if (!viewport || !set || !button || reduceMotion.matches) return;

      viewport.classList.add('is-animated');
      var width = set.getBoundingClientRect().width;
      if (!width) {
        viewport.classList.remove('is-animated');
        return;
      }
      var room = Math.max(viewport.clientWidth, window.screen ? window.screen.width : 0);
      var copies = Math.min(Math.ceil(room / width), 12);
      for (var i = 0; i < copies; i += 1) {
        var copy = set.cloneNode(true);
        copy.removeAttribute('data-af-marquee-set');
        copy.setAttribute('aria-hidden', 'true');
        Array.prototype.forEach.call(copy.querySelectorAll('img'), function (img) { img.alt = ''; });
        Array.prototype.forEach.call(copy.querySelectorAll('[data-shopify-editor-block]'), function (node) {
          node.removeAttribute('data-shopify-editor-block');
        });
        viewport.appendChild(copy);
      }

      /* The state is carried by the button's name alone ("Pause…" / "Play…"), as on the
         announcement bar and the hero; no aria-pressed beside a name that changes. */
      var setPaused = function (paused) {
        marquee.classList.toggle('is-paused', paused);
        button.classList.toggle('is-paused', paused);
        button.removeAttribute('aria-pressed');
        button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
      };
      button.hidden = false;
      setPaused(false);
      button.addEventListener('click', function () {
        setPaused(!marquee.classList.contains('is-paused'));
      });
    });
  }

  /* Footer: on phones each link column's heading becomes a real button that opens
     and closes its content; from 750px the headings are plain headings again. */
  function initFooter() {
    each('[data-af-footer]', function (footer) {
      var phone = window.matchMedia('(max-width: 749px)');
      var headings = Array.prototype.slice.call(footer.querySelectorAll('[data-af-footer-heading]'));

      var apply = function () {
        headings.forEach(function (heading, index) {
          var panel = heading.nextElementSibling;
          if (!panel) return;
          var button = heading.querySelector('.af-footer__toggle');
          if (phone.matches) {
            if (button) return;
            if (!panel.id) panel.id = 'af-footer-panel-' + index;
            button = doc.createElement('button');
            button.type = 'button';
            button.className = 'af-footer__toggle';
            button.setAttribute('aria-expanded', 'false');
            button.setAttribute('aria-controls', panel.id);
            var label = doc.createElement('span');
            while (heading.firstChild) label.appendChild(heading.firstChild);
            button.appendChild(label);
            var mark = doc.createElement('span');
            mark.className = 'af-footer__mark';
            mark.setAttribute('aria-hidden', 'true');
            button.appendChild(mark);
            heading.appendChild(button);
            panel.hidden = true;
            button.addEventListener('click', function () {
              var open = button.getAttribute('aria-expanded') === 'true';
              button.setAttribute('aria-expanded', open ? 'false' : 'true');
              panel.hidden = open;
            });
          } else if (button) {
            var text = button.firstElementChild;
            while (text && text.firstChild) heading.appendChild(text.firstChild);
            heading.removeChild(button);
            panel.hidden = false;
          }
        });
      };
      apply();
      if (phone.addEventListener) phone.addEventListener('change', apply);
    });
  }

  /* Back to top (tablet and desktop only; hidden on phones in CSS) */
  function initBackToTop() {
    each('[data-af-back-to-top]', function (button) {
      var share = parseFloat(button.dataset.afBackToTop);
      if (isNaN(share)) share = 0.6;
      var update = function () {
        var limit = (1 - share) * (doc.body.scrollHeight - window.innerHeight);
        button.classList.toggle('is-visible', window.scrollY > Math.max(limit, window.innerHeight));
      };
      button.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
      window.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  /* Video banner ("Video Text Overlay" section). The video has no source in the
     HTML: a lazy poster image is what the page loads. When the section comes into
     view the film gets the smallest rendition that fills its slot. Liquid prints
     only the largest MP4 (1080p) and the HLS master playlist, so the list of
     renditions is read from the playlist and the MP4 of the chosen one is played
     (the store's CDN serves each rendition both ways; the MP4 is about a third
     lighter than the same rendition's HLS segments and loops from memory). If that
     file does not load, the film falls back to the MP4 Liquid printed. It pauses
     off screen, has a pause button (WCAG 2.2.2) and waits for that button under
     "reduce motion" or data saver. */
  function initVideoText() {
    each('[data-af-video-text]', function (box) {
      var video = box.querySelector('video');
      var button = box.querySelector('[data-af-video-toggle]');
      if (!video || !button || !('IntersectionObserver' in window)) return;

      var connection = navigator.connection || {};
      /* starts paused where the shopper asked for less motion or less data, or the connection is 2G */
      var stopped = reduceMotion.matches || !!connection.saveData || /2g$/.test(connection.effectiveType || '');
      var inView = false;
      var source = null;

      /* renditions printed by Liquid: "1440x1080|url 960x720|url" */
      var mp4s = (video.dataset.mp4 || '').split(/\s+/).map(function (item) {
        var m = /^(\d+)x(\d+)\|(.+)$/.exec(item);
        return m ? { w: +m[1], h: +m[2], url: m[3] } : null;
      }).filter(Boolean);

      /* The smallest rendition at least half as wide as the film is drawn (in CSS
         pixels, whatever the screen's density): it is a moving backdrop behind a
         tint and a heading. Phones and tablets get 480p, screens up to 1920px
         720p, wider ones 1080p. */
      var pick = function (list) {
        if (!list.length) return null;
        list.sort(function (a, b) { return a.w - b.w; });
        for (var i = 0; i < list.length; i += 1) {
          var needed = Math.max(box.clientWidth, box.clientHeight * list[i].w / list[i].h) * 0.5;
          if (list[i].w >= needed) return list[i];
        }
        return list[list.length - 1];
      };

      var fromPlaylist = function (master) {
        return fetch(master)
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (text) {
            var lines = text.split(/\r?\n/);
            var list = [];
            for (var i = 0; i < lines.length - 1; i += 1) {
              var m = /^#EXT-X-STREAM-INF:.*RESOLUTION=(\d+)x(\d+)/.exec(lines[i]);
              var next = lines[i + 1].trim();
              if (m && next && next.charAt(0) !== '#') list.push({ w: +m[1], h: +m[2], url: new URL(next, master).toString() });
            }
            return pick(list);
          })
          .catch(function () { return null; });
      };

      var ensureSource = function () {
        if (source) return source;
        var master = video.dataset.hls ? new URL(video.dataset.hls, window.location.href).toString() : '';
        var fallback = pick(mp4s.slice());
        var native = video.canPlayType('application/vnd.apple.mpegurl') || video.canPlayType('application/x-mpegURL');
        var choose = Promise.resolve(fallback && fallback.url);
        if (master && window.fetch && mp4s.length < 2) {
          choose = fromPlaylist(master).then(function (variant) {
            if (!variant) return fallback && fallback.url;
            /* "<id>.HD-720p.4.5Mbps.hls.<n>_.m3u8" is also served as "<id>.HD-720p-4.5Mbps-<n>.mp4" */
            var m = /^(.*)\.((?:HD|SD)-\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8(\?.*)?$/.exec(variant.url);
            if (m) return m[1] + '.' + m[2] + '-' + m[3] + '-' + m[4] + '.mp4' + (m[5] || '');
            return native ? variant.url : fallback && fallback.url;
          });
        }
        source = choose.then(function (url) {
          if (!url) throw new Error('no video source');
          if (fallback && url !== fallback.url) {
            /* a rendition that does not load gives way, once, to the file Liquid printed */
            var retry = function () {
              video.removeEventListener('error', retry);
              video.src = fallback.url;
              if (inView && !stopped) play();
            };
            video.addEventListener('error', retry);
          }
          video.src = url;
          return url;
        });
        return source;
      };

      var reflect = function () {
        button.classList.toggle('is-paused', stopped);
        button.setAttribute('aria-label', stopped ? button.dataset.labelPlay : button.dataset.labelPause);
      };

      function play() {
        ensureSource().then(function () {
          if (!inView || stopped) return;
          var started = video.play();
          if (started && started.catch) {
            started.catch(function (error) {
              /* the device refused to start it by itself (iPhone Low Power Mode):
                 the button then offers Play instead of showing a film that is not running */
              if (error && error.name === 'NotAllowedError') {
                stopped = true;
                reflect();
              }
            });
          }
        }).catch(function () {});
      }

      video.muted = true;
      video.addEventListener('playing', function () { video.classList.add('is-ready'); });

      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          if (inView && !stopped) play();
          else if (!video.paused) video.pause();
        });
      }, { rootMargin: '200px 0px', threshold: 0.1 }).observe(box);

      button.addEventListener('click', function () {
        stopped = !stopped;
        reflect();
        if (stopped) video.pause();
        else play();
      });
      button.hidden = false;
      reflect();
    });
  }

  function init() {
    initHeader();
    initSlideshows();
    initCarousels();
    initMarquees();
    initFooter();
    initBackToTop();
    initVideoText();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
  doc.addEventListener('shopify:section:load', init);
})();